import { EMPTY_MODULE_API_INFO, EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isStaffOrSuperUser } from "@common/appInfo";
import { createTicket, hideAddModal, updateUser, updateViolation } from "../actions";
import { localStateSelector, makeUploadInfoSelector } from "../selectors";
import { type MemberHelpdesk } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: EMPTY_MODULE_API_INFO,
  canCreateTicket: true,
  error: null,
  isVisible: false,
  status: "None",
  uploadApiInfo: null,
  guidelinesVideoUrl: null,
  guidelines: null,
  violations: null,
  displayHelpdeskGuidelines: false
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const uploadApiInfoSelector = makeUploadInfoSelector(false);

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.newTicket) return INVISIBLE_PROPS;

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      canCreateTicket: !isStaffOrSuperUser(),
      error: localState.error,
      isVisible: true,
      status: localState.status,
      uploadApiInfo: uploadApiInfoSelector(state, props),
      guidelinesVideoUrl: localState.guidelinesVideoUrl,
      guidelines: localState.guidelines,
      violations: localState.guidelineViolations,
      displayHelpdeskGuidelines: localState.displayHelpdeskGuidelines
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onAgree: () => dispatch(updateUser(getEntityRef(props))),
  onClose: () => dispatch(hideAddModal(getEntityRef(props))),
  onCloseViolation: (data: string) => dispatch(updateViolation(getEntityRef(props), data)),
  onSubmit: (data: MemberHelpdesk.View.NewTicket, customFieldIds: string[]) =>
    dispatch(createTicket(getEntityRef(props), data, customFieldIds))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
